import { render } from "./VaccinationPage.vue?vue&type=template&id=4b302425&scoped=true"
import script from "./VaccinationPage.vue?vue&type=script&lang=js"
export * from "./VaccinationPage.vue?vue&type=script&lang=js"

import "./VaccinationPage.vue?vue&type=style&index=0&id=4b302425&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b302425"]])

export default __exports__